import { isTherePortChips } from '@msc-b2c/shared-utils';

export function dynamicPortBannerManagement() {
  // get the search result banner
  function getSearchResultsBannerCF() {
    const bannerElementCF = document.querySelector('.-js-results-banner') as HTMLElement;
    if (bannerElementCF) {
      return bannerElementCF;
    }
    return null;
  }

  // get the target container which is inside the search results EF
  function getTargetContainer() {
    const targetContainer = document.querySelector<HTMLElement>(
      '.-js-ex-results-banner-container > .cmp-container > .aem-Grid'
    );
    if (targetContainer) {
      return targetContainer;
    }
    return null;
  }

  function getElementOuterHeight(element: HTMLElement): number {
    const { height } = element.getBoundingClientRect();
    const computedStyle = window.getComputedStyle(element);
    const marginTop = Number.parseFloat(computedStyle.marginTop) || 0;
    const marginBottom = Number.parseFloat(computedStyle.marginBottom) || 0;

    return Math.ceil(height + marginTop + marginBottom);
  }

  function reserveBannerSpace(targetContainer: HTMLElement, bannerElement: HTMLElement): void {
    const bannerHeight = getElementOuterHeight(bannerElement);
    if (bannerHeight <= 0) return;

    const currentMinHeight = Number.parseFloat(window.getComputedStyle(targetContainer).minHeight);
    targetContainer.style.minHeight = `${Math.max(
      Number.isNaN(currentMinHeight) ? 0 : currentMinHeight,
      bannerHeight
    )}px`;
  }

  // if we have a dynamic port place the banner in right position
  if (isTherePortChips()) {
    const bannerElementCF = getSearchResultsBannerCF();
    const targetContainer = getTargetContainer();
    if (bannerElementCF && targetContainer) {
      reserveBannerSpace(targetContainer, bannerElementCF);
      targetContainer.appendChild(bannerElementCF);
    }
  }
}

function onDocumentReady(): void {
  dynamicPortBannerManagement();
}

if (document.readyState !== 'loading') {
  onDocumentReady();
} else {
  document.addEventListener('DOMContentLoaded', onDocumentReady);
}
